import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { AUTHOR } from '@/lib/org'
import { PageAccessProvider, PageGate } from '@/contexts/PageAccessContext'

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <PageAccessProvider>
    <div className="flex h-screen w-full bg-muted/30">
      {/* Mobile overlay backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuToggle={() => setSidebarOpen(o => !o)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {/* v0.16.0: Suspense trong Layout — chuyển trang lazy vẫn giữ nguyên
              sidebar/header, chỉ vùng nội dung hiện "Đang tải trang…" */}
          <Suspense
            fallback={
              <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
                Đang tải trang…
              </div>
            }
          >
            <PageGate><Outlet /></PageGate>
          </Suspense>
        </main>
        <footer className="flex items-center justify-center gap-2 border-t bg-background px-4 py-1.5 text-center text-[11px] leading-tight text-muted-foreground">
          <img src={AUTHOR.logoUrl} alt="" className="h-6 w-6" aria-hidden />
          <span>
            © {new Date().getFullYear()} {AUTHOR.creditLine1}
            <br />
            {AUTHOR.creditLine2}
          </span>
        </footer>
      </div>
    </div>
    </PageAccessProvider>
  )
}
